import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect } from "react";
import { Trans, useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { OAuthViewModel } from "../../features/oauth/oauth-viewmodel";
import { AppRoutes } from "../../routes/routes";
import { useViewModel } from "../../viewmodel/use-view-model";
export const OAuthCallback = () => {
    const vm = useViewModel(OAuthViewModel);
    const navigate = useNavigate();
    const { t } = useTranslation();
    useEffect(() => {
        const run = async () => {
            const code = getHashedParams(window.location.hash, "code");
            // on load we want to fetch code from URL param and try exchange
            await vm.exchangeCodeForToken(code ?? "");
            // then navigate to user search
            navigate(AppRoutes.User);
        };
        void run();
    }, []);
    return (_jsx(_Fragment, { children: _jsx("div", { className: "d-flex justify-content-center align-items-center", children: _jsxs("div", { className: "card mt-5 mt-5 w-50", children: [_jsx("h6", { className: "card-header pt-2 pb-2", children: t("oauth.login") }), _jsx("div", { className: "card-body", children: _jsx(Trans, { i18nKey: "oauth.success", children: _jsx(Link, { to: AppRoutes.User }) }) })] }) }) }));
};
function getHashedParams(hash, param) {
    if (!hash.includes('?')) {
        return null;
    }
    const params = new URLSearchParams(hash.split('?')[1]);
    return params.get(param);
}
